import { render } from "./TheTeam.vue?vue&type=template&id=49c81120&scoped=true"
import script from "./TheTeam.vue?vue&type=script&lang=js"
export * from "./TheTeam.vue?vue&type=script&lang=js"

import "./TheTeam.vue?vue&type=style&index=0&id=49c81120&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c81120"]])

export default __exports__